import React from 'react'
import { IconChartBar, IconTable } from '@tabler/icons-react'
import { ThemeConfig } from '../../utils/themeConfig'
import { ViewMode } from './ViewModeProvider'

interface ViewModeToggleButtonProps {
  viewMode: ViewMode
  onClick: () => void
  themeConfig: ThemeConfig
  className?: string
}

const ViewModeToggleButton: React.FC<ViewModeToggleButtonProps> = ({ viewMode, onClick, themeConfig, className }) => {
  const isTableMode = viewMode === 'table'
  const Icon = isTableMode ? IconChartBar : IconTable
  const label = isTableMode ? '图形模式' : '表格模式'

  return (
    <div
      className={`flex flex-col items-center justify-center cursor-pointer p-3 transition-all duration-300 hover:scale-105 ${className || ''}`}
      onClick={onClick}
      style={{ backgroundColor: themeConfig.backgroundColor }}
    >
      <Icon size={26} color={themeConfig.primaryColor} />
      <span className="text-gray-500 text-xs font-medium mt-1">{label}</span>
    </div>
  )
}

export default ViewModeToggleButton
